const PaymentScheduleStatusEnum = Object.freeze({
  PENDING_APPROVAL: "PENDING_APPROVAL",
  ACTIVE: "ACTIVE",
  CANCELLED: "CANCELLED",
});

export default PaymentScheduleStatusEnum;
